/** */
export const READ_MANY_LEAD = 'read multiple lead.';
export const ADD_MANY_LEAD_TO_STORE = 'add multiple lead to store.';
export const LOAD_LEADS_TO_STORE = 'load leads to store from API call';
export const REMOVE_ONE_LEAD_FROM_STORE = 'remove one lead from store';
export const REMOVE_MANY_LEAD_FROM_STORE = 'remove many lead from store';
export const ADD_ONE_LEAD_TO_STORE = 'add one lead to store';
export const ADD_SEARCH_RESULTS_TO_STORE = 'add lead search results to store.';
export const UPDATE_ONE_LEAD_IN_STORE = 'update an lead in store.';

/** */
export const readManyLead = (payload) => ({
  type: READ_MANY_LEAD,
  payload
});

export const addManyLeadToStore = (payload) => ({
  type: ADD_MANY_LEAD_TO_STORE,
  payload
});

export const removeOneLeadFromStore = (payload) => ({
  type: REMOVE_ONE_LEAD_FROM_STORE,
  payload
});

export const removeManyLeadFromStore = (payload) => ({
  type: REMOVE_MANY_LEAD_FROM_STORE,
  payload
});

export const addOneLeadToStore = (payload) => ({
  type: ADD_ONE_LEAD_TO_STORE,
  payload
});

export const addLeadSearchResultsToStore = (payload) => ({
  type: ADD_SEARCH_RESULTS_TO_STORE,
  payload
});

export const loadLeadsToStore = (payload) => ({
  type: LOAD_LEADS_TO_STORE,
  payload
});

export const updateLeadInStore = (payload) => ({
  type: UPDATE_ONE_LEAD_IN_STORE,
  payload
});
